/**
 * Minimal interface for voucher with code
 * Avoids circular dependency with sol-buyer-context
 */
interface VoucherWithCode {
  code: string;
}

/**
 * Extract voucher codes from voucher array
 * @param vouchers - Array of vouchers with code property
 * @returns Array of voucher codes as strings
 */
export const extractVoucherCodes = (vouchers: VoucherWithCode[]): string[] => {
  return vouchers.map((voucher) => voucher.code);
};
